import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

//Util
import { ICONES_BOTAO } from "../utils/icones";

/*
 * Modal para apresentar os dados em uma tabela
 */
function ModalTabela({
  modalOpen,
  toggleModal,
  titulo,
  result,
  colunas,
  showFechar = true,
}) {
  return (
    <Modal isOpen={modalOpen} backdrop="static" size="lg">
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        {titulo}
      </ModalHeader>

      <ModalBody>
        <div className="scroll-modal-max">
          <Table responsive>
            <thead>
              <tr>
                {colunas.map((col, index) => (
                  <td
                    key={index}
                    className="table-header"
                    align={col.align || "left"}
                    width={col.width || ""}
                  >
                    {col.nome}
                  </td>
                ))}
              </tr>
            </thead>

            <tbody>
              {result.map((r, index) => (
                <tr key={index}>
                  {colunas.map((col, indexCol) => (
                    <td key={indexCol} align={col.align || "left"}>
                      {r[col.campo] || r}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </ModalBody>

      {showFechar && (
        <ModalFooter>
          <Button name="btnFechar" color="secondary" onClick={toggleModal}>
            {ICONES_BOTAO.FECHAR} Fechar
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}

export default ModalTabela;
